/**
 * @description Image loader composable.
 * It provides a way to handle image loading and error events on <img> elements.
 */
export function useImageLoader() {
  const hasImageLoaded = ref(false)

  /**
   * @description Image loaded handler added to @load event of <img> element.
   */
  function onImageLoad() {
    hasImageLoaded.value = true
  }

  function resetLoadState() {
    hasImageLoaded.value = false
  }

  return {
    hasImageLoaded: readonly(hasImageLoaded),
    onImageLoad,
    resetLoadState
  }
}
